'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFormControlled = require('react-form-controlled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = (_temp = _class = function (_Element) {
  (0, _inherits3.default)(Alert, _Element);

  function Alert() {
    (0, _classCallCheck3.default)(this, Alert);
    return (0, _possibleConstructorReturn3.default)(this, _Element.apply(this, arguments));
  }

  Alert.prototype.componentDidMount = function componentDidMount() {
    var form = this.getForm();
    form.registerChild(this);
  };

  Alert.prototype.componentWillUnmount = function componentWillUnmount() {
    var form = this.getForm();
    form.unregisterChild(this);
  };

  Alert.prototype.originalValueChanged = function originalValueChanged() {
    this.forceUpdate();
  };

  Alert.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        render = _props.render,
        Component = _props.component,
        exact = _props.exact,
        rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'render', 'component', 'exact']);

    var path = this.getPath();
    var form = this.getForm();

    var errors = form.getErrors(path, exact);
    if (!errors || !errors.length) {
      return null;
    }

    if (typeof children === 'function') {
      return this.replaceChildren(children({ errors: errors }));
    } else if (typeof render === 'function') {
      return this.replaceChildren(render({ errors: errors }));
    } else if (Component) {
      return _react2.default.createElement(Component, (0, _extends3.default)({ errors: errors }, rest));
    } else if (children) {
      return children;
    }

    return _react2.default.createElement(
      'div',
      { role: 'alert', className: className },
      errors.map(function (error) {
        return error.message;
      })
    );
  };

  return Alert;
}(_reactFormControlled.Element), _class.propTypes = {
  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  exact: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  render: _propTypes2.default.func,
  component: _propTypes2.default.node,
  className: _propTypes2.default.string
}, _temp);
exports.default = Alert;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled-validate/lib/Alert.js
 ** module id = 1259
 ** module chunks = 0
 **/